import { render, staticRenderFns } from "./vistadeorden.vue?vue&type=template&id=48e461ee"
import script from "./vistadeorden.vue?vue&type=script&lang=js"
export * from "./vistadeorden.vue?vue&type=script&lang=js"
import style0 from "./vistadeorden.vue?vue&type=style&index=0&id=48e461ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports